import { render, staticRenderFns } from "./NotificationTable.vue?vue&type=template&id=f22b27fe"
import script from "./NotificationTable.vue?vue&type=script&lang=js"
export * from "./NotificationTable.vue?vue&type=script&lang=js"
import style0 from "./NotificationTable.vue?vue&type=style&index=0&id=f22b27fe&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports